import { observer } from "mobx-react-lite";
import ProjectStore from "../../../../stores/Admin/ProjectStore";
import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Upload, message } from "antd";
import type { RcFile, UploadFile, UploadProps } from "antd/es/upload/interface";
import { PlusOutlined } from "@ant-design/icons";

export interface ApplicationEditDialogProps {
  visible: boolean;
  close: () => void;
  projectId?: number;
}

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

const beforeUpload = (file: RcFile) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
};
const ApplicationEditDialog: React.FC<ApplicationEditDialogProps> = (props) => {
  const [form] = Form.useForm();
  const [previewImage, setPreviewImage] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  useEffect(() => {
    form.resetFields();
    setFileList([]);
  }, [props.visible, props.projectId]);

  const customReques = (option: any) => {
    const formData = new FormData();
    formData.append("files[]", option.file);
    const reader = new FileReader();
    reader.readAsDataURL(option.file);
    reader.onloadend = function (e) {
      if (e && e.target && e.target.result) {
        option.onSuccess();
      }
    };
  };
  const normFile = (e: any) => {
    console.log("Upload event:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as RcFile);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewVisible(true);
  };
  const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) =>{

    console.log(newFileList)
    setFileList(newFileList);
  }
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  const submit = () => {
    form.validateFields().then(() => {
      const values = form.getFieldsValue();
      const formData = new FormData()
      formData.append('backEndUrl',values.backEndUrl ?? '' )
      formData.append('frontEndUrl',values.frontEndUrl?? '')
      formData.append('name',values.name?? '')
      formData.append('sort',values.sort?? '')
      formData.append('projectId',String(props.projectId)?? '')
      formData.append('account',values.account?? '')
      formData.append(
        "file",
        fileList[0]?.originFileObj ? fileList[0]?.originFileObj : ""
      );
      ProjectStore.addApplication(
        formData
      );
      props.close();
    });
  };

  return (
    <Modal
      title="新建应用"
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      cancelText="取消"
      okText="确认"
    >
      <Form form={form} {...layout}>
        <Form.Item
          label="应用名称"
          name="name"
          rules={[{ required: true, message: "应用名称不能为空" }]}
        >
          <Input placeholder="请输入应用名称" />
        </Form.Item>

        <Form.Item
          label="授权回调地址"
          name="backEndUrl"
          rules={[{ required: true, message: "授权回调地址不能为空" }]}
        >
          <Input placeholder="请输入授权回调地址" />
        </Form.Item>

        <Form.Item label="前端重定向地址" name="frontEndUrl">
          <Input placeholder="请输入前端重定向地址" />
        </Form.Item>

        <Form.Item label="登录账号" name="account">
          <Input placeholder="请输入登录账号" />
        </Form.Item>

        <Form.Item label="排序权重" name="sort">
          <Input type="number" placeholder="请输入排序权重" />
        </Form.Item>
        <Form.Item
          label="首页截图"
          name="picture"
          valuePropName="picture"
          getValueFromEvent={normFile}
        >
          <Upload
            name="picture"
            listType="picture-card"
            className="avatar-uploader"
            fileList={fileList}
            onPreview={handlePreview}
            customRequest={customReques}
            beforeUpload={beforeUpload}
            onChange={handleChange}
          >
            {fileList.length >= 1 ? null : uploadButton}
          </Upload>
          <Modal
            visible={previewVisible}
            title={null}
            footer={null}
            onCancel={() => setPreviewVisible(false)}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default observer(ApplicationEditDialog);
